'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _OverlayTrigger2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/OverlayTrigger.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/OverlayTrigger.js
 ** module chunks = 0
 **/